import React from 'react';

/**
 * RouteLine — the site's signature motif.
 * A dashed shipment route with waypoint markers and an animated
 * orange path that "draws" itself in, echoing the comet trail in
 * the East Star mark and a tracked freight route on a map.
 */
export default function RouteLine({ from = 'ORIGIN', to = 'DESTINATION', light = false }) {
  return (
    <div className={`route-line-wrap ${light ? 'route-divider' : ''}`}>
      <svg className="route-line-svg" viewBox="0 0 600 60" preserveAspectRatio="none" aria-hidden="true">
        <path className="route-line-path" d="M10,46 C150,46 180,10 320,10 C440,10 470,46 590,46" />
        <path className="route-line-path progress" d="M10,46 C150,46 180,10 320,10 C440,10 470,46 590,46" />
        <circle className="route-node start" cx="10" cy="46" r="5" />
        <circle className="route-node" cx="320" cy="10" r="4" />
        <circle className="route-node end" cx="590" cy="46" r="5" />
        <text x="10" y="59" className="route-marker-label">{from}</text>
        <text x="590" y="59" textAnchor="end" className="route-marker-label">{to}</text>
      </svg>
    </div>
  );
}
